import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import CourseSlider from '../Courses/CourseSlider';
import { axiosInstance, config } from '../config';
import '../../../assets/styles/courseCards.css';

const CourseSection = () => {
  const [Cources, setCourses] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getCources();
  }, []);

  function getCources() {
    axiosInstance
      .get(`get-cources`)
      .then((res) => {
        setCourses(res.data.cources.filter((co) => co.status == '0'));
      })
      .catch((err) => console.log(err));
  }

  return (
    <section className="courses-section">
      <div className="auto-container">
        <div className="home-course-header">
          <h2>Popular Courses</h2>
          <Link to={`${config.appUrl}courses`} className="course-view-all">
            View All Courses
            <i className="bi bi-arrow-right"></i>
          </Link>
        </div>
        {Cources.length > 0 ? (
          <CourseSlider title="" courses={Cources} />
        ) : null}
      </div>
    </section>
  );
};

export default CourseSection;
